import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React from 'react';

const ConfirmActionDialog = ({
                                 openDialog,
                                 handleCloseDialog,
                                 actionToConfirm,
                                 title = 'Bestätigung erforderlich',
                                 content = 'Sind Sie sicher, dass Sie diese Aktion durchführen möchten?'
                             }) => {
    return (
        <Dialog open={openDialog} onClose={handleCloseDialog}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText>{content}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseDialog}>Abbrechen</Button>
                <Button onClick={async () => {
                    await actionToConfirm();
                    handleCloseDialog();
                }} color="primary" autoFocus> Bestätigen </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmActionDialog;
